import React, { Suspense } from 'react';
import { Button, Form, Input } from 'antd';
import ErrorBoundary from '../components/ErrorBoundary';
import { useMutation, useSuspenseQuery } from '@tanstack/react-query';
import { fetchPrintServer, upsertPrintServer } from './api';
import message from '~/utils/message';
import { PrintServerFormValues } from './types';
import Loading from '../components/Loading';

const rules = [
  {
    required: true,
    message: 'Please input this field',
  },
];

const PrintServerForm = () => {
  const { data, isLoading } = useSuspenseQuery({
    queryKey: ['printServer'],
    queryFn: fetchPrintServer,
    retry: false,
    gcTime: 0,
  });
  const { isPending, mutate } = useMutation({
    mutationFn: upsertPrintServer,
    retry: false,
    onSuccess: () => {
      message.success('Successfully updated print server');
    },
    onError: () => {
      message.error('Fail to update print server');
    },
  });

  const onSubmit = (values: PrintServerFormValues) => {
    mutate(values);
  };
  if (isLoading) return null;

  return (
    <Form initialValues={data} onFinish={onSubmit} layout="vertical">
      <Form.Item name="ipAddress" label="IP address" rules={rules}>
        <Input placeholder="Ex: 192.168.0.10:9100" />
      </Form.Item>
      <Button htmlType="submit" type="primary" loading={isPending}>
        Submit
      </Button>
    </Form>
  );
};

const PrintServer = () => {
  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl">Print Server</h1>
      </div>
      <div className="max-w-[800px]">
        <ErrorBoundary>
          <Suspense fallback={<Loading />}>
            <PrintServerForm />
          </Suspense>
        </ErrorBoundary>
      </div>
    </div>
  );
};

export default PrintServer;
